import React from "react";
import Utils from "../../utils/utils";

// Components
import Cookies from "universal-cookie";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import getEsami from "../../services/getEsami";
import getStudenti from "../../services/getStudenti";
import getCorsi from "../../services/getCorsi";
import moment from "moment";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

export default class PdfSingleStudent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courses: [],
      coursesIds: [],
      exams: [],
      grades: [],
      ids: [],
      averages: [],
      isReadyToShow: false,
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const studentID = cookies.get("requestedStudent", { path: "/" });

    this.corsi = await getCorsi(username, token);
    this.studenti = await getStudenti(username, token);
    this.currentStudent = this.studenti.filter((s) => s.id == studentID)[0];

    this.corsi = this.corsi.filter((corso) => {
      const corsiArray = Utils.parseCorsi(this.currentStudent.corsi);
      const corsiRitiroArray = Utils.parseCorsi(
        this.currentStudent.corsi_ritiro,
      );
      return (
        corsiArray.includes(corso.id.toString()) ||
        corsiRitiroArray.includes(corso.id.toString())
      );
    });

    var courses = [];
    var averages = [];
    var examDetails = [];
    var coursesIds = [];
    var grades = [];
    var ids = [];

    for (var corso of this.corsi) {
      coursesIds.push(corso.id);
      courses.push(corso.name);

      var gradesSum = 0.0;
      const courseExams = await getEsami(username, token, corso.id);
      const courseValutazioni = await getValutazioniCorso(
        username,
        token,
        corso.id
      );
      const studentExams = courseValutazioni.filter(
        (esame) => esame.id_studente == studentID && esame.valutazione != -1
      );

      var esamiCorso = [];

      courseExams.forEach((esameCorso) => {
        studentExams.forEach((esameStudente) => {
          if (esameCorso.id == esameStudente.id_esame) {
            var esami = [];

            gradesSum += parseFloat(esameStudente.valutazione);
            esami.push(esameCorso.nome.toUpperCase() + ": " + esameCorso.data);
            esami.push(esameStudente.valutazione);
            esamiCorso.push(esami);
          }
        });
      });
      const avg =
        studentExams.length == 0
          ? "N/A"
          : (gradesSum / studentExams.length).toFixed(2);
      examDetails.push(esamiCorso);
      averages.push(avg);
    }

    console.error(examDetails);

    this.setState({
      coursesIds: coursesIds,
      ids: ids,
      exams: examDetails,
      grades: grades,
      courses: courses,
      averages: averages,
      isReadyToShow: true,
    });
  }

  render() {
    const timeNow = moment().format("yyyy-MM-DD HH:mm:ss");
    console.error(this.state.exams);

    return (
      <div style={{ width: "100%", height: "100%" }} key={Math.random()}>
        {this.state.isReadyToShow && (
          <PDFViewer style={{ width: "100%", height: "100%" }}>
            <Document>
              {this.state.coursesIds.map((id, index) => {
                if (index == 0) {
                  return (
                    <Page
                      size="A4"
                      style={{ paddingTop: 80, paddingBottom: 50 }}
                      orientation="portrait"
                      wrap
                    >
                      <View style={{ marginTop: -60 }}>
                        <Image
                          style={{
                            position: "absolute",
                            top: 30,
                            left: 30,
                            width: "20%",
                            height: "auto",
                          }}
                          src={require("../../images/loghi/nero_trasparente.png")}
                        />
                        <Text
                          style={{
                            position: "absolute",
                            top: 35,
                            right: 40,
                            fontSize: 12,
                            width: "100%",
                            textAlign: "right",
                            color: "#999999",
                          }}
                        >
                          {timeNow}
                        </Text>
                        <Text
                          style={{
                            margin: 10,
                            fontSize: 20,
                            width: "100%",
                            textAlign: "center",
                            marginTop: "80px",
                            paddingHorizontal: 40,
                          }}
                        >
                          Dettaglio esami studente
                        </Text>
                        <Text
                          style={{
                            fontSize: 16,
                            width: "100%",
                            textAlign: "center",
                            marginTop: 0,
                            color: "#999999",
                          }}
                        >
                          {this.currentStudent.cognome}{" "}
                          {this.currentStudent.nome}
                        </Text>
                        <View key={Math.random()} style={styles.page}>
                          <Text
                            style={{
                              margin: 10,
                              fontSize: 16,
                              maxWidth: "100%",
                              marginRight: "5%",
                              textAlign: "left",
                              marginLeft: "5%",
                            }}
                          >
                            {this.state.courses[index]}
                          </Text>
                          {this.currentStudent.corsi_ritiro.includes(
                            id + ";"
                          ) && (
                            <Text
                              style={{
                                fontSize: 16,
                                width: "100%",
                                textAlign: "left",
                                marginLeft: "5%",
                                marginBottom: "5px",
                                color: "red",
                              }}
                            >
                              Studente ritirato da questo corso
                            </Text>
                          )}
                          <View style={styles.row}>
                            <View
                              style={{
                                ...styles.columnLeft,
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              <Text>ESAME</Text>
                            </View>
                            <View
                              style={{
                                ...styles.columnRight,
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              <Text>VALUTAZIONE</Text>
                            </View>
                          </View>

                          {this.state.exams[index].map((exam) => {
                            return (
                              <View key={Math.random()}>
                                <View style={{ ...styles.row, marginTop: -1 }}>
                                  <View style={styles.columnLeft}>
                                    <Text
                                      style={{ alignItems: "center", flex: 1 }}
                                    >
                                      {exam[0]}
                                    </Text>
                                  </View>
                                  <View style={styles.columnRight}>
                                    <Text
                                      style={{
                                        alignItems: "center",
                                        flex: 1,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {exam[1]}
                                    </Text>
                                  </View>
                                </View>
                              </View>
                            );
                          })}
                          <Text
                            style={{
                              alignSelf: "flex-end",
                              marginRight: "5%",
                              marginTop: "15px",
                              fontWeight: "bold",
                              fontSize: 14,
                            }}
                          >
                            Media complessiva: {this.state.averages[index]}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          position: "absolute",
                          bottom: 50,
                          left: 0,
                          width: "100%",
                          backgroundColor: "#FFFFFF",
                          textAlign: "right",
                        }}
                      >
                        <Text
                          style={{
                            fontWeight: "light",
                            fontSize: 9,
                            color: "#BDBDBD",
                            marginRight: 50,
                          }}
                        >
                          Pagina {index + 1} di {this.state.coursesIds.length}
                        </Text>
                      </View>
                    </Page>
                  );
                } else {
                  return (
                    <Page
                      size="A4"
                      style={{ paddingTop: 80, paddingBottom: 50 }}
                      orientation="portrait"
                      wrap
                    >
                      <View style={{ marginTop: -40 }}>
                        <View key={Math.random()} style={styles.page}>
                          <Text
                            style={{
                              margin: 10,
                              fontSize: 16,
                              maxWidth: "100%",
                              marginRight: "5%",
                              textAlign: "left",
                              marginLeft: "5%",
                            }}
                          >
                            {this.state.courses[index]}
                          </Text>
                          {this.currentStudent.corsi_ritiro.includes(
                            id + ";"
                          ) && (
                            <Text
                              style={{
                                fontSize: 16,
                                width: "100%",
                                textAlign: "left",
                                marginLeft: "5%",
                                marginBottom: "5px",
                                color: "red",
                              }}
                            >
                              Studente ritirato da questo corso
                            </Text>
                          )}
                          <View style={styles.row}>
                            <View
                              style={{
                                ...styles.columnLeft,
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              <Text>ESAME</Text>
                            </View>
                            <View
                              style={{
                                ...styles.columnRight,
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              <Text>VALUTAZIONE</Text>
                            </View>
                          </View>

                          {this.state.exams[index].map((exam) => {
                            return (
                              <View key={Math.random()}>
                                <View style={{ ...styles.row, marginTop: -1 }}>
                                  <View style={styles.columnLeft}>
                                    <Text
                                      style={{ alignItems: "center", flex: 1 }}
                                    >
                                      {exam[0]}
                                    </Text>
                                  </View>
                                  <View style={styles.columnRight}>
                                    <Text
                                      style={{
                                        alignItems: "center",
                                        flex: 1,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {exam[1]}
                                    </Text>
                                  </View>
                                </View>
                              </View>
                            );
                          })}
                          <Text
                            style={{
                              alignSelf: "flex-end",
                              marginRight: "5%",
                              marginTop: "15px",
                              fontWeight: "bold",
                              fontSize: 14,
                            }}
                          >
                            Media complessiva: {this.state.averages[index]}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          position: "absolute",
                          bottom: 50,
                          left: 0,
                          width: "100%",
                          backgroundColor: "#FFFFFF",
                          textAlign: "right",
                        }}
                      >
                        <Text
                          style={{
                            fontWeight: "light",
                            fontSize: 9,
                            color: "#BDBDBD",
                            marginRight: 50,
                          }}
                        >
                          Pagina {index + 1} di {this.state.coursesIds.length}
                        </Text>
                      </View>
                    </Page>
                  );
                }
              })}
            </Document>
          </PDFViewer>
        )}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    display: "flex",
    border: "1 solid #000",
    width: "90%",
    marginLeft: "5%",
    minHeight: "30px",
  },

  page: {
    fontSize: 10,
    backgroundColor: "#ffffff",
    padding: 10,
    marginTop: "20px",
  },

  columnLeft: {
    flexDirection: "column",
    width: "50%",
    borderRight: "1 solid #000",
    textAlign: "left",
    paddingHorizontal: 30,
    paddingVertical: 10,
    flex: 1,
  },

  columnRight: {
    flexDirection: "column",
    textAlign: "center",
    paddingHorizontal: 30,
    paddingVertical: 10,
    flex: 1,
  },
});
